import BookIcon from '@/images/BookIcon.svg?react';
import { Box } from '@/components/Box/Box';
import { UserDetailsIcon } from '@/bundle/_Opco/shared/styles';
import { Typography } from '@/components/Typography/Typography';
import { COLORS } from '@/styles/colors';
import { CookiesManagePreferencesModal } from '@/bundle/CookiesBanner/CookiesManagePreferencesModal/CookiesManagePreferencesModal';
import { useState } from 'react';
import { CookiesPreferencesType, useCookiesPreferences } from '@/bundle/CookiesBanner/cookiesContext';
import { CookiePreferencesButton } from '@/bundle/shared/components/ProfileCookiesPreferences/styles';

export const ProfileCookiesPreferences = () => {
  const { preferences, save } = useCookiesPreferences();
  const [isOpenModal, setIsOpenModal] = useState(false);

  const saveCookiesPreferences = (newPreference: CookiesPreferencesType) => {
    save(newPreference);
    setIsOpenModal(false);
  };

  return (
    <>
      <Box display='flex' alignItems='center' columnGap='16px'>
        <UserDetailsIcon>
          <BookIcon />
        </UserDetailsIcon>
        <Box display='flex' flexDirection='row' alignItems='center' columnGap='4px'>
          <Typography variant='bodySmall' color={COLORS.grey[600]}>
            Manage your
          </Typography>
          <CookiePreferencesButton onClick={() => setIsOpenModal(true)}>Cookies Preferences</CookiePreferencesButton>
        </Box>
      </Box>
      <CookiesManagePreferencesModal
        preferences={preferences}
        isOpen={isOpenModal}
        onSave={saveCookiesPreferences}
        onClose={() => setIsOpenModal(false)}
      />
    </>
  );
};
